import React from 'react';

import { SkeletonItem } from '@qality/common-components/src/atoms/SkeletonItem';
import { Table } from '@qality/common-components/src/atoms/Table';

import { Columns, ColumnsWidths } from '../../../TestCaseRepositoryTable';

const SkeletonItemsWidths: Record<Columns, `${number}px` | `${number}%`> = {
  dnd: '20px',
  checkbox: '20px',
  key: '90%',
  summary: '90%',
  project: '90%',
  priority: '20px',
  status: '90%',
  assignee: '20px',
  menu: '20px',
};

type Props = {
  numberOfRows?: number;
  style?: React.CSSProperties;
};

export function TableBodyRowsSkeleton({
  numberOfRows = 10,
  style,
}: Props): JSX.Element {
  return (
    <>
      {Array.from({ length: numberOfRows }).map((_, index) => {
        return (
          <Table.Tr key={`body-skeleton-row-${index}`} style={style}>
            <Table.Td widths={ColumnsWidths.dnd}>
              <Table.ContentHelper justifyContent='center'>
                <SkeletonItem width={SkeletonItemsWidths.checkbox} />
              </Table.ContentHelper>
            </Table.Td>

            <Table.Td widths={ColumnsWidths.checkbox}>
              <Table.ContentHelper justifyContent='center'>
                <SkeletonItem width={SkeletonItemsWidths.checkbox} />
              </Table.ContentHelper>
            </Table.Td>

            <Table.Td widths={ColumnsWidths.key}>
              <Table.ContentHelper>
                <SkeletonItem width={SkeletonItemsWidths.key} />
              </Table.ContentHelper>
            </Table.Td>

            <Table.Td widths={ColumnsWidths.summary}>
              <Table.ContentHelper>
                <SkeletonItem width={SkeletonItemsWidths.summary} />
              </Table.ContentHelper>
            </Table.Td>

            <Table.Td widths={ColumnsWidths.project}>
              <Table.ContentHelper>
                <SkeletonItem width={SkeletonItemsWidths.project} hasIcon />
              </Table.ContentHelper>
            </Table.Td>

            <Table.Td widths={ColumnsWidths.priority}>
              <Table.ContentHelper justifyContent='center'>
                <SkeletonItem
                  width={SkeletonItemsWidths.priority}
                  hasIcon
                  hasNoBar
                />
              </Table.ContentHelper>
            </Table.Td>

            <Table.Td widths={ColumnsWidths.status}>
              <Table.ContentHelper>
                <SkeletonItem width={SkeletonItemsWidths.status} />
              </Table.ContentHelper>
            </Table.Td>

            <Table.Td widths={ColumnsWidths.assignee}>
              <Table.ContentHelper justifyContent='center'>
                <SkeletonItem
                  width={SkeletonItemsWidths.assignee}
                  hasAvatar
                  hasNoBar
                />
              </Table.ContentHelper>
            </Table.Td>

            <Table.Td widths={ColumnsWidths.menu}>
              <Table.ContentHelper justifyContent='center'>
                <SkeletonItem width={SkeletonItemsWidths.menu} />
              </Table.ContentHelper>
            </Table.Td>
          </Table.Tr>
        );
      })}
    </>
  );
}
